import { useEffect, useState } from 'react';
import { apiGet } from '../../lib/apiClient.js';

interface HealthState {
  api: 'checking' | 'healthy' | 'unhealthy';
  version: string;
  metrics: Record<string, unknown>;
}

export function StatusModule(): JSX.Element {
  const [state, setState] = useState<HealthState>({ api: 'checking', version: '—', metrics: {} });

  useEffect(() => {
    void Promise.all([
      apiGet<{ status: string; version?: string }>('/api/v1/health').catch(() => ({ data: { status: 'error' } })),
      apiGet<{ version?: string }>('/version').catch(() => ({ data: {} })),
      apiGet<{ metrics?: Record<string, unknown> }>('/metrics/application').catch(() => ({ data: {} })),
    ]).then(([health, version, metrics]) => {
        const versionData = version.data as { version?: string };
        const metricsData = metrics.data as { metrics?: Record<string, unknown> };
        setState({ api: health.data.status === 'ok' ? 'healthy' : 'unhealthy', version: versionData.version ?? '—', metrics: metricsData.metrics ?? {} });
    });
  }, []);

  return (
    <div className="status-module">
      <div className="header"><h2>System Status</h2></div>
      <div className="status-grid">
        <div className="metric-card"><strong className={`health-${state.api}`}>{state.api}</strong><span>API</span></div>
        <div className="metric-card"><strong>{state.version}</strong><span>Version</span></div>
        {Object.entries(state.metrics).map(([key, value]) => <div className="metric-card" key={key}><strong>{String(value)}</strong><span>{key}</span></div>)}
      </div>
      <p className="muted">Last checked {new Date().toLocaleString()}</p>
    </div>
  );
}